import { useState, useEffect } from 'react';
import { useQuery } from 'data-fetching-client';
import { GET_INVOICES, GET_SUBSCRIPTIONS } from '../queries';
import { GET_PAYMENT_METHODS_QUERY } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerBillingDataRpc.dfc.new';
import { useAppSelector } from '../redux';
import { getEmail, getPortalId } from '../features/BillingPortal/BillingPortalSlice';
import { useCursorPagination, getPaginationInfo } from './useCursorPagination';
const ITEMS_PER_PAGE = 10;
const useBillingAndPaymentsData = () => {
  var _invoicesData$invoice2, _subscriptionsData$su2, _invoicesData$invoice3, _subscriptionsData$su3, _paymentMethodsData$r, _paymentMethodsData$r2;
  const email = useAppSelector(getEmail);
  const portalId = useAppSelector(getPortalId);
  const [previousInvoices, setPreviousInvoices] = useState([]);
  const [previousSubscriptions, setPreviousSubscriptions] = useState([]);
  const invoicesPagination = useCursorPagination();
  const subscriptionsPagination = useCursorPagination();
  const {
    loading: subscriptionsLoading,
    error: getSubscriptionsError,
    data: subscriptionsData
  } = useQuery(GET_SUBSCRIPTIONS, {
    variables: {
      email,
      portalId,
      limit: ITEMS_PER_PAGE,
      after: subscriptionsPagination.currentCursor
    }
  });
  const {
    loading: invoicesLoading,
    error: getInvoicesError,
    data: invoicesData
  } = useQuery(GET_INVOICES, {
    variables: {
      email,
      portalId,
      limit: ITEMS_PER_PAGE,
      after: invoicesPagination.currentCursor
    }
  });
  const {
    loading: paymentMethodsLoading,
    error: getPaymentMethodsError,
    data: paymentMethodsData
  } = useQuery(GET_PAYMENT_METHODS_QUERY);
  useEffect(() => {
    var _invoicesData$invoice;
    if (invoicesData !== null && invoicesData !== void 0 && (_invoicesData$invoice = invoicesData.invoices) !== null && _invoicesData$invoice !== void 0 && _invoicesData$invoice.results) {
      setPreviousInvoices(invoicesData.invoices.results);
    }
  }, [invoicesData === null || invoicesData === void 0 || (_invoicesData$invoice2 = invoicesData.invoices) === null || _invoicesData$invoice2 === void 0 ? void 0 : _invoicesData$invoice2.results]);
  useEffect(() => {
    var _subscriptionsData$su;
    if (subscriptionsData !== null && subscriptionsData !== void 0 && (_subscriptionsData$su = subscriptionsData.subscriptions) !== null && _subscriptionsData$su !== void 0 && _subscriptionsData$su.results) {
      setPreviousSubscriptions(subscriptionsData.subscriptions.results);
    }
  }, [subscriptionsData === null || subscriptionsData === void 0 || (_subscriptionsData$su2 = subscriptionsData.subscriptions) === null || _subscriptionsData$su2 === void 0 ? void 0 : _subscriptionsData$su2.results]);
  const invoicesPagingInfo = getPaginationInfo(invoicesPagination.currentPage, invoicesData === null || invoicesData === void 0 || (_invoicesData$invoice3 = invoicesData.invoices) === null || _invoicesData$invoice3 === void 0 ? void 0 : _invoicesData$invoice3.paging);
  const subscriptionsPagingInfo = getPaginationInfo(subscriptionsPagination.currentPage, subscriptionsData === null || subscriptionsData === void 0 || (_subscriptionsData$su3 = subscriptionsData.subscriptions) === null || _subscriptionsData$su3 === void 0 ? void 0 : _subscriptionsData$su3.paging);
  return {
    loading: subscriptionsLoading || invoicesLoading || paymentMethodsLoading,
    error: getSubscriptionsError || getInvoicesError || getPaymentMethodsError,
    data: {
      subscriptions: previousSubscriptions,
      invoices: previousInvoices,
      paymentMethods: (_paymentMethodsData$r = paymentMethodsData === null || paymentMethodsData === void 0 || (_paymentMethodsData$r2 = paymentMethodsData.result) === null || _paymentMethodsData$r2 === void 0 ? void 0 : _paymentMethodsData$r2.results) !== null && _paymentMethodsData$r !== void 0 ? _paymentMethodsData$r : []
    },
    invoices: {
      currentPage: invoicesPagination.currentPage,
      hasMore: invoicesPagingInfo.hasMore,
      pageCount: invoicesPagingInfo.pageCount,
      onPageChange: newPage => invoicesPagination.onPageChange(newPage, invoicesPagingInfo.nextCursor),
      loading: invoicesLoading
    },
    subscriptions: {
      currentPage: subscriptionsPagination.currentPage,
      hasMore: subscriptionsPagingInfo.hasMore,
      pageCount: subscriptionsPagingInfo.pageCount,
      onPageChange: newPage => subscriptionsPagination.onPageChange(newPage, subscriptionsPagingInfo.nextCursor),
      loading: subscriptionsLoading
    }
  };
};
export default useBillingAndPaymentsData;